/**
 * Email validation utilities
 */

/**
 * Validates an email address using a comprehensive regex pattern
 * that follows RFC 5322 specification guidelines
 *
 * @param email - The email address to validate
 * @returns true if the email is valid, false otherwise
 */
export function validateEmail(email: string): boolean {
  if (!email || typeof email !== "string") {
    return false;
  }

  // Remove leading and trailing whitespace
  email = email.trim();

  // Check for empty string after trimming
  if (email.length === 0) {
    return false;
  }

  // Check for basic structure (must contain @ and .)
  if (!email.includes("@") || email.indexOf("@") !== email.lastIndexOf("@")) {
    return false;
  }

  // Split into local and domain parts
  const atIndex = email.indexOf("@");
  const localPart = email.substring(0, atIndex);
  const domainPart = email.substring(atIndex + 1);

  // Check length constraints
  if (localPart.length === 0 || localPart.length > 64) {
    return false;
  }

  if (domainPart.length === 0 || domainPart.length > 253) {
    return false;
  }

  // Check total email length
  if (email.length > 254) {
    return false;
  }

  // Comprehensive email regex pattern
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  return emailRegex.test(email);
}
